export default "__VITE_ASSET__$nAErec8__"